module.exports = __webpack_public_path__ + "assets/b34a17537efe3d68e4c357ea253c13fc.png";